export default () => {

    const $form_certificado = $('#form-certificado');

    if ($form_certificado.length) {
        $form_certificado.steps({
            headerTag: "h3",
            bodyTag: "section",
            transitionEffect: "slideLeft",
            enableKeyNavigation: false,
            labels: {
                cancel: "Cancelar",
                current: "Step atual",
                pagination: "Paginação",
                finish: "Confirmar",
                next: "Próximo",
                previous: "Anterior",
                loading: "Carregando ..."
            },
            onInit: function (event, currentIndex) {
                const input = $form_certificado.find(".body:eq(" + currentIndex + ") input:not([type=\"radio\"]), .body:eq(" + currentIndex + ") textarea");
                if (input.length) {
                    setTimeout(() => {
                        input[0].focus();
                        input[0].click();
                    }, 200);
                }
            },
            onStepChanging: function (event, currentIndex, newIndex) {

                // Allways allow previous action even if the current form is not valid!
                if (currentIndex > newIndex) {
                    return true;
                }

                $form_certificado.validate().settings.ignore = ":disabled,:hidden";
                const valid_form = $form_certificado.valid();

                if (valid_form) {
                    const input = $form_certificado.find(".body:eq(" + currentIndex + ") input, .body:eq(" + currentIndex + ") textarea");

                    if (input.length) {
                        const i = input[0];
                        const el_target = document.querySelectorAll('.' + i.name);
                        let value = '';

                        if (i.getAttribute("type") && i.getAttribute("type").toLowerCase() === "radio") {
                            value = document.querySelector('label[for="' + i.id + '"]').innerText;
                        } else
                            value = i.value;

                        el_target.forEach((el) => el.innerHTML = value);

                    }

                }

                return valid_form;

            },
            onStepChanged: function (event, currentIndex, priorIndex) {
                const input = $form_certificado.find(".body:eq(" + currentIndex + ") input:not([type=\"radio\"]), .body:eq(" + currentIndex + ") textarea");

                if (input.length) {
                    input[0].focus();
                    input[0].click();
                }

            },
            onFinished: function (event, currentIndex) {
                $form_certificado.submit();
            }
        });
    }

};